import ReactOnRails from 'react-on-rails/client';
import StaticPagesDisclaimer from '../../app/StaticPagesDisclaimer.js';

ReactOnRails.register({StaticPagesDisclaimer});